import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    sessions: {
        entities: {},
        ids: [],
    },
};
const promptSessionsSlice = createSlice({
    name: 'promptSessions',
    initialState,
    reducers: {
        addSession(state, action) {
            const session = action.payload;
            state.sessions.entities[session.id] = session;
            if (!state.sessions.ids.includes(session.id)) {
                state.sessions.ids.push(session.id);
            }
        },
        updateSession(state, action) {
            const { id, changes } = action.payload;
            const existing = state.sessions.entities[id];
            if (existing) {
                Object.assign(existing, changes);
            }
        },
        removeSession(state, action) {
            const id = action.payload;
            delete state.sessions.entities[id];
            state.sessions.ids = state.sessions.ids.filter(sid => sid !== id);
        },
        setSessionStatus(state, action) {
            const { id, status } = action.payload;
            const existing = state.sessions.entities[id];
            if (existing) {
                existing.status = status;
            }
        },
        addDocumentContext(state, action) {
            const { sessionId, documentId } = action.payload;
            const session = state.sessions.entities[sessionId];
            if (session && !session.documentContextIds.includes(documentId)) {
                session.documentContextIds.push(documentId);
            }
        },
        removeDocumentContext(state, action) {
            const { sessionId, documentId } = action.payload;
            const session = state.sessions.entities[sessionId];
            if (session) {
                session.documentContextIds = session.documentContextIds.filter(id => id !== documentId);
            }
        },
        addSkillPrompt(state, action) {
            const { sessionId, skillPrompt } = action.payload;
            const session = state.sessions.entities[sessionId];
            if (session) {
                session.skillPrompts.push(skillPrompt);
            }
        },
        removeSkillPrompt(state, action) {
            const { sessionId, skillPromptId } = action.payload;
            const session = state.sessions.entities[sessionId];
            if (session) {
                session.skillPrompts = session.skillPrompts.filter(sp => sp.id !== skillPromptId);
            }
        },
        updateSkillPrompt(state, action) {
            const { sessionId, skillPromptId, changes } = action.payload;
            const session = state.sessions.entities[sessionId];
            if (session) {
                const sp = session.skillPrompts.find(s => s.id === skillPromptId);
                if (sp) {
                    for (const [key, value] of Object.entries(changes)) {
                        if (value === undefined) {
                            delete sp[key];
                        }
                        else {
                            sp[key] = value;
                        }
                    }
                }
            }
        },
    },
});
export const { addSession, updateSession, removeSession, setSessionStatus, addDocumentContext, removeDocumentContext, addSkillPrompt, removeSkillPrompt, updateSkillPrompt, } = promptSessionsSlice.actions;
export default promptSessionsSlice.reducer;
//# sourceMappingURL=promptSessionsSlice.js.map